import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Heading from '../heading/Heading';
import Wrapper from "../wrapper/Wrapper";
import { apiUtil } from '../../util/apiUtil';
import { mobileAppUtil } from '../../util/mobileAppUtil';
import { addCatagoryUpsell } from "../../util/ga-analytics/ecomm/cartPreview";
import { useHistory } from "react-router-dom";
import ducks from "../../ducks";
import { connect } from 'react-redux';
var retail = ducks.retail;
var operations = retail.operations;
var pageChange = operations.pageChange;

var RetailCategoryCard = function RetailCategoryCard(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields,
      _props$layout = props.layout,
      proplayout = _props$layout === void 0 ? {} : _props$layout,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {
    return "";
  } : _props$onClick,
      _props$setCurrentPage = props.setCurrentPage,
      setCurrentPage = _props$setCurrentPage === void 0 ? function () {
    return '';
  } : _props$setCurrentPage;
  var _fields$items = fields.items,
      items = _fields$items === void 0 ? {} : _fields$items;
  var heading = items.heading,
      background = items.background,
      padding = items.padding,
      link = items.link,
      _items$categories = items.categories,
      categories = _items$categories === void 0 ? [] : _items$categories;

  var layout = _objectSpread({
    background: background || 'default',
    padding: padding || 'medium'
  }, proplayout);

  var showBorder = "Shop by category" === heading;
  var id = 0;
  return Array.isArray(categories) && /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-retail__category ".concat(showBorder ? "show-border" : "")
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "cb-type--center w-100 pt-6"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: heading
    },
    className: "cb-card__category-title"
  }), Boolean(link === null || link === void 0 ? void 0 : link.href) && /*#__PURE__*/React.createElement("a", {
    href: link.href,
    title: link.title
  }, "or Shop by Category")), /*#__PURE__*/React.createElement(Row, {
    className: "cb-retail__orb-link--group"
  }, Array.isArray(categories) ? categories.map(function (category) {
    id++;
    var linkModel = {
      value: {
        text: category.displayName,
        href: category.categoryContentPagePath
      }
    };
    return /*#__PURE__*/React.createElement(OrbLink, _extends({
      setCurrentPage: setCurrentPage,
      key: 'link' + id + category
    }, category, {
      onClick: onClick,
      linkModel: linkModel
    }));
  }) : null)))));
};

var OrbLink = function OrbLink(props) {
  var categoryContentPagePath = props.categoryContentPagePath,
      displayName = props.displayName,
      _props$image = props.image,
      image = _props$image === void 0 ? {
    src: "",
    alt: ""
  } : _props$image,
      _props$onClick2 = props.onClick,
      onClick = _props$onClick2 === void 0 ? function () {
    return "";
  } : _props$onClick2,
      linkModel = props.linkModel,
      setCurrentPage = props.setCurrentPage;
  var isMobileApp = mobileAppUtil.isMobileApp();
  var history = useHistory();

  var linkClicked = function linkClicked(e) {
    onClick(e);
    setCurrentPage(0);
    history.push(categoryContentPagePath);
  };

  if (isMobileApp) {
    var _url, _url2, _url3;

    var url = image === null || image === void 0 ? void 0 : image.src;

    if ((_url = url) === null || _url === void 0 ? void 0 : _url.includes(apiUtil.API.baseUrl)) {
      url = url.replace(apiUtil.API.baseUrl, '');
    }

    if (((_url2 = url) === null || _url2 === void 0 ? void 0 : _url2.includes('http:')) || ((_url3 = url) === null || _url3 === void 0 ? void 0 : _url3.includes('https:'))) {} else {
      var _props$image2;

      url = props === null || props === void 0 ? void 0 : (_props$image2 = props.image) === null || _props$image2 === void 0 ? void 0 : _props$image2.src;
    }

    return /*#__PURE__*/React.createElement(Col, {
      lg: "2",
      sm: "6"
    }, /*#__PURE__*/React.createElement("a", {
      href: '#',
      onClick: linkClicked,
      className: "cb-retail__orb-link"
    }, /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: image === null || image === void 0 ? void 0 : image.alt
    }), /*#__PURE__*/React.createElement("p", null, displayName)));
  } else {
    return /*#__PURE__*/React.createElement(Col, {
      lg: "2",
      sm: "6"
    }, /*#__PURE__*/React.createElement("a", {
      href: '#',
      onClick: linkClicked,
      className: "cb-retail__orb-link"
    }, /*#__PURE__*/React.createElement("img", {
      src: image === null || image === void 0 ? void 0 : image.src,
      alt: image === null || image === void 0 ? void 0 : image.alt
    }), /*#__PURE__*/React.createElement("p", null, displayName)));
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    retail: state.retail
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setCurrentPage: function setCurrentPage(currentPage) {
      return dispatch(pageChange(currentPage));
    }
  };
};

export var RetailCategoryCards = connect(mapStateToProps, mapDispatchToProps)(RetailCategoryCard);